import { render } from "./DeviceEditDetail.vue?vue&type=template&id=0cb52b36&scoped=true"
import script from "./DeviceEditDetail.vue?vue&type=script&lang=js"
export * from "./DeviceEditDetail.vue?vue&type=script&lang=js"

import "./DeviceEditDetail.vue?vue&type=style&index=0&id=0cb52b36&lang=css&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb52b36"]])

export default __exports__